import * as React from "react";
import { ReactElement, useState } from "react";
import "./LeaderboardWidget.scss";
import { LeaderboardWidgetProps, LeaderboardWidgetPosition } from "./LeaderboardWidget.types";
import LeaderboardItem from "./LeaderboardItem";
import { shallowEqual, useSelector } from "react-redux";
import { IApplicationState } from "src/spintr/reducer";
import { Label, SpintrUser, UserHovercard } from "src/ui";
import { circleSmall } from "src/ui/helpers/style";
import classNames from "classnames";

function LeaderboardWidget({ data, variables }: LeaderboardWidgetProps): ReactElement {
  const [positions, setPositions] = useState<LeaderboardWidgetPosition[]>(data.positions);

  const {
    currentUser
  } = useSelector((state: IApplicationState) => ({
    currentUser: state.profile.active
  }), shallowEqual);

  const top10 = positions.slice(0, 10);

  return (
    <div className={classNames("LeaderboardWidget-container", {
      "isPreview": data.isPreview,
    })}>
      <div className="content">
        {top10.map((item, index) => (
          <>
            <LeaderboardItem
              key={item.email || item.officeCode + index}
              item={item}
              isOnPodium={item.ranking <= 3}
              typeOfStatistics={data.typeOfStatistics}
              variables={variables} />
            {index < top10.length - 1 && (
              <div className="LeaderboardWidget-separator" />
            )}
          </>
        ))}
        {currentUser && (
          <UserHovercard userId={currentUser.id}>
            <div className="LeaderboardItem current-user">
              <div className="info">
                <SpintrUser
                  imageUrl={currentUser.images["250x999"] || ""}
                  name={currentUser.username || ""}
                  hideText={true}
                  personalName={true}
                  size={circleSmall} />
                <div className="info-text">
                  <div className="ranking-circle">
                    <Label size="small-2">
                      {data?.currentPosition}
                    </Label>
                  </div>
                </div >
              </div >
            </div >
          </UserHovercard >
        )
        }
      </div >
    </div >
  );
};

export default LeaderboardWidget;
